import { useBlock, useSlate } from '@tribeplatform/react-slate-kit/hooks'
import type { BC } from '@tribeplatform/react-slate-kit/types'

import { PostCard } from './components/PostCard'
import type { SinglePostBlockProps } from './types'

export const SinglePostBlock: BC<SinglePostBlockProps> = ({
  postId,
  fields,
  postTypeId,
  postTypeSlug,
}) => {
  const { mode } = useSlate()
  const {
    extraContext: { activeFieldId },
  } = useBlock<SinglePostBlockProps, { activeFieldId?: string }>()
  const preview = mode !== 'live'

  return (
    <PostCard
      postId={postId}
      fields={fields}
      postTypeId={postTypeId}
      postTypeSlug={postTypeSlug}
      activeFieldId={activeFieldId}
      preview={preview}
    />
  )
}
